// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.employee-list-modal-background {
  display: flex;
  align-items: center;
  justify-content: center;
}

.employee-list-modal {
  width: 400px;
  background-color: white;
  border-radius: 16px;
}
.employee-list-modal__modal-action {
  margin-left: auto;
}
.employee-list-modal__modal-action__close {
  cursor: pointer;
}
.employee-list-modal__head-span {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 26px;
  line-height: 36px;
  color: #49ae9e;
}
.employee-list-modal__modal-header {
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 41px;
  color: #353d47;
}
.employee-list-modal__modal-subheader {
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #566370;
  padding: 10px 0 0 0;
}
.employee-list-modal__modal-body {
  position: relative;
  padding-top: 30px;
}
.employee-list-modal__modal-table {
  border-collapse: collapse;
  width: 100%;
}
.employee-list-modal__modal-tr {
  line-height: 50px;
  letter-spacing: -0.6px;
  color: #8b8b8b;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  border-top: 1px solid #868686;
}
.employee-list-modal__modal-tr__content {
  line-height: 50px;
  border-top: 1px solid #dfdfdf;
}
.employee-list-modal__modal-tr__head {
  padding-left: 10px;
}
.employee-list-modal__modal-td {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #505054;
  padding-left: 10px;
}
.employee-list-modal__modal-td__name {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.employee-list-modal__button {
  margin-top: 10%;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/staff-registration/employee-list-modal/employee-list-modal.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AACJ;;AAEA;EACI,YAAA;EACA,uBAAA;EACA,mBAAA;AACJ;AACI;EACI,iBAAA;AACR;AAAQ;EACI,eAAA;AAEZ;AAEI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAAR;AAGI;EACI,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AADR;AAII;EACI,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AAFR;AAKI;EACI,kBAAA;EACA,iBAAA;AAHR;AAMI;EACI,yBAAA;EACA,WAAA;AAJR;AAOI;EACI,iBAAA;EACA,sBAAA;EACA,cAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;AALR;AAOQ;EACI,iBAAA;EACA,6BAAA;AALZ;AAQQ;EACI,kBAAA;AANZ;AAUI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AARR;AAUQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AARZ;AAYI;EACI,eAAA;EACA,WAAA;AAVR","sourcesContent":[".employee-list-modal-background {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.employee-list-modal {\n    width: 400px;\n    background-color: white;\n    border-radius: 16px;\n\n    &__modal-action {\n        margin-left: auto;\n        &__close {\n            cursor: pointer;\n        }\n    }\n\n    &__head-span {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 26px;\n        line-height: 36px;\n        color: #49ae9e;\n    }\n\n    &__modal-header {\n        font-family: 'Noto Sans KR';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 28px;\n        line-height: 41px;\n        color: #353d47;\n    }\n\n    &__modal-subheader {\n        font-family: 'Noto Sans KR';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        color: #566370;\n        padding: 10px 0 0 0;\n    }\n\n    &__modal-body {\n        position: relative;\n        padding-top: 30px;\n    }\n\n    &__modal-table {\n        border-collapse: collapse;\n        width: 100%;\n    }\n\n    &__modal-tr {\n        line-height: 50px;\n        letter-spacing: -0.6px;\n        color: #8b8b8b;\n        font-family: 'Noto Sans KR';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        border-top: 1px solid #868686;\n\n        &__content {\n            line-height: 50px;\n            border-top: 1px solid #dfdfdf;\n        }\n\n        &__head {\n            padding-left: 10px;\n        }\n    }\n\n    &__modal-td {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        color: #505054;\n        padding-left: 10px;\n\n        &__name {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 14px;\n            line-height: 20px;\n            color: #505054;\n        }\n    }\n\n    &__button {\n        margin-top: 10%;\n        width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
